import { pathOr } from 'ramda';

import { IApplicationState } from '../../types/redux';

export const getPros = (state: IApplicationState): string => {
  return pathOr('', ['newReview', 'data', 'pros', 'value'], state);
};
